var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discord_black_18dp\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 217,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "0309\\u66F4\\u65B0-\\u9996\\u9875",
    transform: "translate(-775.000000, -1993.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(0.000000, 1972.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(635.000000, 20.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discord_black_18dp\\u5907\\u4EFD",
    transform: "translate(140.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 30 0 30 30 0 30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(3.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.3843979,19.7791482 C18.7063979,20.0071482 19.1213979,20.0641482 19.4913979,19.9241482 C19.8613979,19.7831482 20.1333979,19.4671482 20.2153979,19.0841482 C21.0843979,15.0001482 23.1923979,4.66314821 23.9833979,0.948148211 C24.0433979,0.668148211 23.9433979,0.377148211 23.7233979,0.190148211 C23.5033979,0.00314821085 23.1983979,-0.0508517891 22.9263979,0.0501482109 C18.7333979,1.60214821 5.82039785,6.44714821 0.542397854,8.40014821 C0.207397854,8.52414821 -0.0106021463,8.84614821 0.000397853713,9.19914821 C0.0123978537,9.55314821 0.250397854,9.86014821 0.593397854,9.96314821 C2.96039785,10.6711482 6.06739785,11.6561482 6.06739785,11.6561482 C6.06739785,11.6561482 7.51939785,16.0411482 8.27639785,18.2711482 C8.37139785,18.5511482 8.59039785,18.7711482 8.87939785,18.8471482 C9.16739785,18.9221482 9.47539785,18.8431482 9.69039785,18.6401482 C10.9063979,17.4921482 12.7863979,15.7171482 12.7863979,15.7171482 C12.7863979,15.7171482 16.3583979,18.3361482 18.3843979,19.7791482 Z M7.37439785,11.1021482 L9.05339785,16.6401482 L9.42639785,13.1331482 C9.42639785,13.1331482 15.9133979,7.28214821 19.6113979,3.94714821 C19.7193979,3.84914821 19.7343979,3.68514821 19.6443979,3.57014821 C19.5553979,3.45514821 19.3913979,3.42814821 19.2683979,3.50614821 C14.9823979,6.24314821 7.37439785,11.1021482 7.37439785,11.1021482 Z",
    id: "telegram-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a94fb4b0b2564d74cf7641189189cee8.svg";
export { ForwardRef as ReactComponent };